import React from "react"
import { Accordion, Card } from "react-bootstrap"
import {Link} from "gatsby"

function CollapsibleList({ data }) {

  const { stateObjects } = data

  return (
    <div className={`container`}>
      {stateObjects &&
      stateObjects.map((item, index) => (
        <Accordion key={`state-${index}`}>
          <Card>
              <Accordion.Toggle as={Card.Header} variant={`link`} eventKey={index}>
                {item.stateName}
              </Accordion.Toggle>
            <Accordion.Collapse eventKey={index} >
              <Card.Body>
                <div className={`local`}>
                  <ul>
                    {item.stateCities &&
                    item.stateCities.map((city, i) => (
                      <li key={`state-${city}-${i}`}><Link to={city.link}>{city.area_name}</Link></li>
                    ))
                    }
                  </ul>
                </div>
                <p className={`card-text`}>View more cities in <Link to={item.stateLink}>{item.stateName}</Link></p>
              </Card.Body>
            </Accordion.Collapse>

          </Card>
        </Accordion>
      ))
      }
    </div>
  )
}

export default CollapsibleList
